// The numbers of a period: the totals for the tiles and the per-question averages for the cards.

import { getReadinessTotal } from "./baseline";
import { READINESS_KEYS } from "./constants";
import { dayNumToUtc } from "./dates";
import { mean, round1 } from "./math";

/**
 * Builds the questions for the readiness report.
 * @param {*} params
 * @returns
 */
export const buildQuestions = ({
  periodDays,
  previousEntries,
  normal,
  showChange,
}) =>
  READINESS_KEYS.map((key) => {
    const average = mean(
      periodDays.map((d) => d.answers.find((a) => a.key === key).value)
    );
    const previousAverage = mean(previousEntries.map((e) => e.readiness[key]));
    const usual = normal?.ready ? normal[key] : null;
    return {
      key,
      avg: round1(average),
      prevAvg: round1(previousAverage),
      change:
        showChange && average != null && previousAverage != null
          ? round1(average - previousAverage)
          : null,
      usual,
      below: average != null && usual != null && average < usual.lo,
      series: periodDays.map((d) => {
        const answer = d.answers.find((a) => a.key === key);
        return {
          utcDate: d.utcDate,
          value: answer.value,
          lo: answer.lo,
          hi: answer.hi,
        };
      }),
    };
  });

/**
 * Builds the summary for the readiness report.
 * @param {*} params
 * @returns
 */
export const buildSummary = ({
  questionnaireDays,
  previousEntries,
  showChange,
  counted,
  missed,
  overlays,
}) => {
  const average = mean(questionnaireDays.map((d) => d.total));
  const previousAverage = mean(
    previousEntries.map((e) => getReadinessTotal(e.readiness))
  );
  const completedTraining = counted.length - missed.length;
  const hasChange = showChange && previousAverage != null;
  return {
    avg: round1(average),
    prevAvg: round1(previousAverage),
    change: hasChange ? round1(average - previousAverage) : null,
    questionnaires: questionnaireDays.length,
    judged: questionnaireDays.filter((d) => d.status !== "learning").length,
    below: questionnaireDays.filter((d) => d.status === "below").length,
    trainingDays: counted.length,
    completedTrainingDays: completedTraining,
    completionPct:
      counted.length > 0
        ? Math.round((completedTraining / counted.length) * 100)
        : null,
    missedDays: missed.map(dayNumToUtc),
    avgRpe: round1(mean(overlays.sessionRpe.map((point) => point.value))),
  };
};
